// extracted by mini-css-extract-plugin
export default {"tooltip":"_2Thfd","showTooltip":"_1PZX-"};